/**
 * Application Constants
 * 
 * Centralized location for all constants used throughout the application.
 * This provides a single source of truth for configuration values.
 */

// API Configuration
export const API_BASE_URL = "https://ampyfin-website-pyj4.onrender.com";

// API Endpoints
export const API_ENDPOINTS = {
  PORTFOLIO_PERCENTAGE: '/portfolio_percentage',
  HOLDINGS: '/holdings',
  RANKINGS: '/rankings',
  RECENT_TRADES: '/recent_trades',
  TICKER: '/ticker',
  VALUATION_DATA: '/valuation_data',
  LOGIN: '/login',
  SIGNUP: '/signup',
  DASHBOARD: '/dashboard',
};

// Route Paths
export const ROUTES = {
  HOME: '/',
  HOW_IT_WORKS: '/how-it-works',
  PORTFOLIO: '/portfolio',
  RANKINGS: '/rankings',
  TRADES: '/trades',
  BENCHMARK: '/benchmark',
  VALUATION_DATA: '/valuation-data',
  MISSION: '/mission',
  OUR_MODELS: '/our-models',
  OPEN_SOURCE: '/open-source',
  DEMO: '/demo',
  LOGIN: '/login',
  SIGNUP: '/signup',
  DASHBOARD: '/dashboard',
  ARTICLE: '/article',
  // Backtest Results
  PRAG_V3_RESULTS: '/prag-v3-results',
  HYPER_V3_RESULTS: '/hyper-v3-results',
  HYPER_V4_RESULTS: '/hyper-v4-results',
  PRAG_V4_RESULTS: '/prag-v4-results',
};

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'ampyfin_token',
  THEME: 'ampyfin_theme',
  LANGUAGE: 'ampyfin_language',
};

// Default Values
export const DEFAULTS = {
  LANGUAGE: 'en',
  THEME: 'dark',
  PAGE_SIZE: 10,
  DEBOUNCE_DELAY: 300,
};

// Confidence Levels
export const CONFIDENCE_LEVELS = {
  HIGH: 70,
  MEDIUM: 50,
  LOW: 0,
};

// Date/Time Formats
export const DATE_FORMATS = {
  SHORT: { month: 'short', day: 'numeric', year: 'numeric' },
  TIME: { hour: '2-digit', minute: '2-digit' },
  FULL: { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' },
};

// Number Formatting
export const NUMBER_FORMATS = {
  LOCALE: 'en-US',
  CURRENCY: 'USD',
  DECIMAL_PLACES: 2,
};

// Component Sizes
export const COMPONENT_SIZES = {
  MAX_COMPONENT_LINES: 300,
  MAX_FILE_SIZE: 500,
};

// Animation Durations (ms)
export const ANIMATION_DURATIONS = {
  FAST: 200,
  NORMAL: 300,
  SLOW: 500,
  VERY_SLOW: 1000,
};

// Breakpoints (px)
export const BREAKPOINTS = {
  MOBILE: 480,
  TABLET: 768,
  DESKTOP: 1024,
  LARGE_DESKTOP: 1440,
};

